module.exports = __webpack_public_path__ + "static/img/card3.b7fb9051.png";